export function calculateRepeatDuration(duration, repeat, repeatDelay) {
    return duration * (repeat + 1) + repeatDelay * repeat;
}
//# sourceMappingURL=calc-repeat-duration.js.map